import axios from "axios";
import Vue from "vue";
import store from "../store";

const app = new Vue();

const instance = axios.create({
  //baseURL: "http://localhost/api",
  //baseURL: "http://172.17.3.5/CampusApi/api",
  baseURL: "https://segreteria.patristicum.org/CampusApi/api",
  headers: {
    ApiKey: "771686f0-359d-488c-a783-b47921558f8f",
  },
});

instance.interceptors.request.use((config) => {
  (config.headers.Token = store.getters.getToken), app.$isLoading(true);

  const token = localStorage.getItem("jwt_token");

  // Aggiungi il token solo se esiste e se la chiamata lo richiede
  // Per default tutte le chiamate richiedono autenticazione,
  // tranne quelle che specificano requiresAuth: false
  if (token && config.requiresAuth !== false) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    app.$isLoading(false);

    // Controlla se è presente l'header X-New-Token e aggiorna il localStorage
    const newToken = response.headers["x-new-token"];
    if (newToken) {
      console.log("Token JWT aggiornato dal server");
      localStorage.setItem("jwt_token", newToken);
    }

    return response;
  },
  (error) => {
    app.$isLoading(false);

    // Se riceviamo un errore 401 (Unauthorized), rimuoviamo il token scaduto
    if (error.response && error.response.status === 401) {
      console.log("Token JWT non valido o scaduto, rimozione dal localStorage");
      localStorage.removeItem("jwt_token");
    }

    return Promise.reject(error);
  },
);

export default instance;
